export const GlobalConnex = {
    // url: "/api/"
    url: process.env.REACT_APP_API_URL || "/api/",
};